export const USER_ROLES = {
  ADMIN: "Administrador",
  SUPERVISOR: "Supervisor",
};

export const USER_PERMISSIONS = {
  PROJECTIONS_MODULE: [USER_ROLES.ADMIN],
};
